import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { calculateTax } from 'actions/stripe';
import { useDispatch } from 'react-redux';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import Body from 'pages/sales-report/table/Body';
import OrderTableHead from 'pages/sales-report/table/Head';

const useStyles = makeStyles({
  container: {
    margin: '30px 0',
    boxShadow: '4px 4px 10px #d9d9d9, -4px -4px 10px #fff',
    borderRadius: '10px',
  },
});

const OrderTable = ({ data = [] }) => {
  const classes = useStyles();

  const dispatch = useDispatch();
  const [taxInfo, setTaxInfo] = useState(null);

  useEffect(() => {
    const getData = async () => {
      const data = await dispatch(calculateTax());
      setTaxInfo(data);
    };

    if (!taxInfo) {
      getData();
    }
  }, [dispatch, taxInfo]);

  return (
    <TableContainer className={classes.container} component={Paper}>
      <Table stickyHeader>
        <OrderTableHead />
        <TableBody>
          {!!taxInfo && <Body data={data} taxInfo={taxInfo} />}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default OrderTable;
